module.exports = __webpack_public_path__ + "img/trf_va.4be50963.png";